import { FetchJsonProps, useReactQueryFetchJson } from '@apeiron/temp'
import ENV_CONFIG from '@src/config'
import { battleDemoFragmentsSchema } from '@src/deserialize/yup/battleDemo'
import { BattleDemoFragment } from '@src/types/battleDemo'
import * as R from 'ramda'

const useFetchBattleDemoFragmentJson = (props?: FetchJsonProps) => {
  const { fetchNow } = props || {}

  return useReactQueryFetchJson<BattleDemoFragment[]>({
    fetchNow,
    path: ENV_CONFIG.JSON_FILE_NAME.BATTLE_DEMO_FRAGMENTS,
    deserialize: (response: any) => {
      return R.map((data: Record<string, any>) => {
        return battleDemoFragmentsSchema.cast(data) as BattleDemoFragment
      }, response)
    }
  })
}

export default useFetchBattleDemoFragmentJson
